import { useEffect, useRef } from 'react';
import { AmpAccessToken, AuthCallbacks } from './Auth';

export interface TokenReloaderCallbacks {
  currentAccessToken: AmpAccessToken | null;
}

// TODO(TSP-1778, TSP-1788): Remove this effect
export const useTokenReloaderEffect = (authcallbacks: AuthCallbacks, cb: (token: AmpAccessToken) => boolean) => {
  const currentAccessToken = useRef<AmpAccessToken | null>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!authcallbacks.accessToken.current) {
        return;
      }

      if (!currentAccessToken.current || currentAccessToken.current.token !== authcallbacks.accessToken.current.token) {
        const result = cb(authcallbacks.accessToken.current);
        if (!result) {
          return;
        }
        currentAccessToken.current = authcallbacks.accessToken.current;
      }
    }, 50);

    return () => {
      clearInterval(interval);
      currentAccessToken.current = null;
    };
  }, [authcallbacks, currentAccessToken, cb]);
};
